<template>
	<div class="my-paging-box">
		<el-pagination 
			@size-change="handleSizeChange" 
			@current-change="handleCurrentChange" 
			:page-sizes="pageSizes" 
			:page-size="pageObj.pageSize" 
			:pager-count="5"
			align="middle"
			:current-page.sync="pageObj.targetPage"
			layout="total, sizes, prev, pager, next, jumper" 
			:total="pageObj.totalPage"
			class="page-box">
		</el-pagination>
	</div>
</template>
<script>
	export default {
        name: 'pubPage',
        props:{
		    pageObj:{
		       type:Object,
		       default: () => ({})
		    },
		    pageSizes: {
		    	default () {
		    		return [1, 10, 20, 50, 100];
		    	}
		    },
		    isBase: {
		    	default: false
		    }
		},
        data() {
            return {
            	
            }
        },
        created() {
            
        },
        methods: {
        	//每页条数改变
        	handleSizeChange(val) {
        		if (this.isBase) {
        			this.$emit('baseChangePage',val,true);
        		} else {
        			if(this.pageObj.type == 2){
						this.$emit('changePage1',val,true);
					}else{
						this.$emit('changePage',val,true);
					}
        		}
            },
            //页码改变
            handleCurrentChange(val) {
            	if (this.isBase) {
            		this.$emit('baseChangePage',val,false);
            	} else {
            		if(this.pageObj.type == 2){
						this.$emit('changePage1',val,false);
					}else{
						this.$emit('changePage',val,false);
					}
            	}
            },
        }
    }
</script>

<style scoped>
.my-paging-box {
	width: 100%;
	height:50px;
	padding-top:30px;
	overflow-x: auto;
}
</style>